import {IUserState} from "./types";
import {Reducer} from "redux";
import {ActionType, getType} from "typesafe-actions";
import * as actions from './actions';

export type UserAction = ActionType<typeof actions>;


const initialUserState: IUserState = {
    currentUser: null
};

export const userReducer: Reducer<IUserState, UserAction> = (
    state = initialUserState,
    action
) => {
    switch (action.type) {
        case getType(actions.loginAsyncActions.success): {
            return {
                ...state,
                currentUser: action.payload.user
            }
        }
        case getType(actions.logoutAsyncActions.success) : {
            return {
                ...state,
                currentUser: null
            }
        }
        default: {
            return state
        }
    }
}